import React from 'react';
import { motion } from 'framer-motion';
import FormInput from './FormInput';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiMail, FiPhone, FiMapPin } = FiIcons;

const StepOne = ({ formData, updateFormData, errors }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.4 }}
      className="w-full"
    >
      <div className="text-center mb-8">
        <motion.div
          animate={{ rotate: [0, 10, -10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="text-6xl mb-4"
        >
          🍛
        </motion.div>
        <h2 className="text-2xl font-bold text-brand-primary mb-2">
          Let's Get Started!
        </h2>
        <p className="text-brand-primary/70 text-lg">
          Tell us about yourself so we can deliver delicious tiffins to you
        </p>
      </div>

      <FormInput
        label="Your Name"
        icon={FiUser}
        value={formData.name}
        onChange={(e) => updateFormData('name', e.target.value)}
        placeholder="Enter your full name"
        error={errors.name}
        success={formData.name && !errors.name}
        required
      />

      <FormInput
        label="Email Address"
        type="email"
        icon={FiMail}
        value={formData.email}
        onChange={(e) => updateFormData('email', e.target.value)}
        placeholder="your.email@example.com"
        error={errors.email}
        success={formData.email && !errors.email}
        required
      />

      <FormInput
        label="WhatsApp Number"
        type="tel"
        icon={FiPhone}
        value={formData.whatsapp}
        onChange={(e) => updateFormData('whatsapp', e.target.value)}
        placeholder="+91 98765 43210"
        error={errors.whatsapp}
        success={formData.whatsapp && !errors.whatsapp}
        required
      />

      <FormInput
        label="PIN Code"
        type="text"
        icon={FiMapPin}
        value={formData.pincode}
        onChange={(e) => updateFormData('pincode', e.target.value)}
        placeholder="400001"
        error={errors.pincode}
        success={formData.pincode && !errors.pincode}
        required
        maxLength={6}
      />

      <div className="bg-brand-cream p-4 rounded-2xl border-l-4 border-brand-orange">
        <div className="flex items-start space-x-3">
          <SafeIcon icon={FiPhone} className="text-brand-orange text-xl mt-1 flex-shrink-0" />
          <div>
            <p className="text-brand-primary font-semibold mb-1">WhatsApp Updates</p>
            <p className="text-brand-primary/70 text-sm">
              We'll send order updates and delivery notifications on WhatsApp for your convenience.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default StepOne;